import './About.scss'
import AboutBlurb from '../../Components/AboutBlurb/AboutBlurb'

function About() {
  return (
    <div className='about'>
      <AboutBlurb />
    </div>
  )
}

export default About